export default __webpack_public_path__ + "static/media/ic-pdf.8b71df0a.svg";